export default "__VITE_ASSET__pRlco8mg__"